export default __webpack_public_path__ + "static/media/iFitTokenStr.d6b72ff6.png";